import {
  // GroupRounded,
  ReceiptRounded,
  AccountCircleOutlined,
  AdminPanelSettingsOutlined,
  CreditCardOutlined,
  DesktopWindowsOutlined,
  EditNotificationsOutlined,
  EnergySavingsLeafOutlined,
  LocalPoliceOutlined,
  PeopleAltOutlined,
} from '@mui/icons-material';

export enum TypeTabSetting {
  information = 'information',
  notifications = 'notifications',
  password = 'password',
  activities = 'activities',
  visibility = 'visibility',
  devices_manager = 'devices_manager',
  plan_usage = 'plan_usage',
  members = 'members',
  payment_history = 'payment_history',
  payment_method = 'payment_method',
}

export const TABS_SETTING: ITabSetting[] = [
  {
    key: TypeTabSetting.information,
    label: 'Information',
    icon: AccountCircleOutlined,
  },
  {
    key: TypeTabSetting.password,
    label: 'Password',
    icon: AdminPanelSettingsOutlined,
  },
  {
    key: TypeTabSetting.devices_manager,
    label: 'Device Manager',
    icon: DesktopWindowsOutlined,
    disable: false,
  },
  {
    key: TypeTabSetting.plan_usage,
    label: 'Plan & Usage',
    icon: EnergySavingsLeafOutlined,
    disable: false,
  },
  // {
  //   key: TypeTabSetting.activities,
  //   label: 'Activities',
  //   icon: GroupRounded,
  //   disable: true,
  // },
  {
    key: TypeTabSetting.payment_history,
    label: 'Payment History',
    icon: ReceiptRounded,
    disable: false,
  },

  {
    key: TypeTabSetting.payment_method,
    label: 'Payment Method',
    icon: CreditCardOutlined,
    disable: true,
  },
  {
    key: TypeTabSetting.notifications,
    label: 'Notifications',
    icon: EditNotificationsOutlined,
    disable: true,
  },
  {
    key: TypeTabSetting.visibility,
    label: 'Visibility',
    icon: LocalPoliceOutlined,
    disable: true,
  },
  {
    key: TypeTabSetting.members,
    label: 'Members',
    icon: PeopleAltOutlined,
    disable: true,
  },
];
